export const CLEAR_NAVIGATION = 'NAVIGATION::CLEAR_NAVIGATION';
